/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('ClearingBatchServiceApi', ($http, ApiErrorService) => {
    return {
        getRunningBatch: getRunningBatch,
        getAllBatches: getAllBatches,
        getMessageTraceCountForBatch: getMessageTraceCountForBatch,
        syncBatches: syncBatches,
        startNewBatch: startNewBatch,
        endBatch: endBatch
    };
    function getRunningBatch(userId, simulatorId) {
        return $http.get(`api/ClearingBatch/${userId}/${simulatorId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllBatches(userId, simulatorId) {
        return $http.get(`api/ClearingBatch/${userId}/${simulatorId}/All`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getMessageTraceCountForBatch(userId, simulatorId, batchId, testSuiteId) {
        return $http.get(`api/ClearingBatch/${userId}/${simulatorId}/Traces/Count?batchId=${batchId}&testSuiteId=${testSuiteId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function syncBatches(userId, simulatorId) {
        return $http.post(`api/ClearingBatch/${userId}/${simulatorId}/sync`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function startNewBatch(userId, simulatorId, reference) {
        return $http.post(`api/ClearingBatch/${userId}/${simulatorId}?reference=${encodeURIComponent(reference)}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function endBatch(userId, simulatorId) {
        return $http.post(`api/ClearingBatch/${userId}/${simulatorId}/Delete`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
